import { createAxiosInstance } from '@/apis/axios.utils';
import { env } from '@/env';

export const axios = createAxiosInstance(env.creatorsApiUrl, {
  camelizeKeys: true,
});

export async function searchAccounts(
  {
    brandId,
    sources,
    followersGreaterThan,
    followersLessThan,
    bioIncludes,
    bioDoesNotInclude,
    captionsInclude,
    captionsDoNotInclude,
    bioOrCaptionsInclude,
    hasMentionedBrand,
    hasPostedBetween,
    interests,
    paidInterests,
    countryCodes,
    locations,
    handle,
    visualFeatures,
    audience,
    languages,
    minAvgViews,
    maxAvgViews,
    minMedianViews,
    maxMedianViews,
    sortBy,
    minEngagementRate,
    maxEngagementRate,
    limit,
    afterCursor,
    competitiveMentions,
    minCreatorRate,
    maxCreatorRate,
    stateProvinces,
    gender,
    ageBucket,
    minEngagedAccounts,
    maxEngagedAccounts,
    instagram,
  },
  axiosConfig = {},
) {
  const url = `/accounts`;
  const payload = {
    brandId,
    sources,
    followersGreaterThan,
    followersLessThan,
    bioIncludes,
    bioDoesNotInclude,
    captionsInclude,
    captionsDoNotInclude,
    bioOrCaptionsInclude,
    hasMentionedBrand,
    hasPostedBetween,
    interests,
    paidInterests,
    countryCodes,
    locations,
    handle,
    visualFeatures,
    audience,
    languages,
    minAvgViews,
    maxAvgViews,
    minMedianViews,
    maxMedianViews,
    sortBy,
    limit,
    minEngagementRate,
    maxEngagementRate,
    afterCursor,
    competitiveMentions,
    minCreatorRate,
    maxCreatorRate,
    stateProvinces,
    gender,
    ageBucket,
    minEngagedAccounts,
    maxEngagedAccounts,
    instagram,
  };
  return axios.put(url, payload, { ...axiosConfig });
}

export async function searchAccountsForTeaser(
  {
    brandId,
    sources,
    followersGreaterThan,
    followersLessThan,
    bioIncludes,
    bioDoesNotInclude,
    captionsInclude,
    captionsDoNotInclude,
    bioOrCaptionsInclude,
    hasMentionedBrand,
    hasPostedBetween,
    predictedInterests,
    predictedLocations,
    handle,
    visualFeatures,
    sortBy,
  },
  axiosConfig = {},
) {
  const url = `teaser/accounts`;
  const payload = {
    brandId,
    sources,
    followersGreaterThan,
    followersLessThan,
    bioIncludes,
    bioDoesNotInclude,
    captionsInclude,
    captionsDoNotInclude,
    bioOrCaptionsInclude,
    hasMentionedBrand,
    hasPostedBetween,
    predictedInterests,
    estimatedRegions: predictedLocations,
    handle,
    visualFeatures,
    sortBy,
  };
  return axios.put(url, payload, { ...axiosConfig });
}

export async function fetchAccount({ source, sourceCreatorId, handle, brandId }, axiosConfig = {}) {
  return axios.get(`/accounts/${source}`, {
    ...axiosConfig,
    params: { brandId, sourceCreatorId, handle },
  });
}

export async function fetchBrandCreators({
  url,
  brandId,
  creatorIds,
  postsPublishedStartDate,
  postsPublishedEndDate,
  instagramPostType,
  youtubePostType,
  afterCursor,
  limit,
}) {
  return axios.put(url ?? `/brands/${brandId}/relationships`, {
    creatorIds,
    postsPublishedStartDate,
    postsPublishedEndDate,
    postType: instagramPostType || youtubePostType,
    afterCursor,
    limit,
  });
}

export async function fetchBrandCreator({ url, brandId, creatorId }) {
  return axios.get(url ?? `/brands/${brandId}/relationships/${creatorId}`);
}

export async function updateCreatorDetails({ url, brandId, creatorId, creatorDetails }) {
  return axios.put(url ?? `/brands/${brandId}/relationships/${creatorId}/details`, creatorDetails);
}

export async function fetchBrandRelationshipTags({ url, brandId }) {
  return axios.get(url ?? `/brands/${brandId}/relationships/tags`);
}

export async function createInformationRequest({ brandId, creatorId }) {
  return axios.put(`/brands/${brandId}/relationships/${creatorId}/information_requests`);
}

export async function fetchInformationRequest({ token }) {
  return axios.get(`/information_requests?token=${token}`);
}

export async function submitInformationRequest({ token, creatorData }, axiosConfig = {}) {
  const payload = { token, ...creatorData };
  return axios.put(`/information_requests`, payload, { ...axiosConfig });
}

export async function bulkImportCreators({ brandId, creators }, axiosConfig = {}) {
  return axios.post(
    `/brands/${brandId}/relationships/bulk_imports`,
    { creators },
    { ...axiosConfig },
  );
}

export async function bulkDeleteRelationships({ brandId, creatorIds }, axiosConfig = {}) {
  return axios.post(
    `/brands/${brandId}/relationships/bulk_delete`,
    { creatorIds },
    { ...axiosConfig },
  );
}

export async function addRelationshipTag({ brandId, creatorId, name, color }, axiosConfig = {}) {
  return axios.post(
    `/brands/${brandId}/relationships/${creatorId}/tags`,
    { name, color },
    { ...axiosConfig },
  );
}

export async function bulkAddRelationshipTags({ brandId, creatorIds, tags }, axiosConfig = {}) {
  return axios.post(
    `/brands/${brandId}/relationships/tags`,
    { creatorIds, tags },
    { ...axiosConfig },
  );
}

export async function deleteRelationshipTag({ brandId, creatorId, tagId }, axiosConfig = {}) {
  return axios.delete(`/brands/${brandId}/relationships/${creatorId}/tags/${tagId}`, {
    ...axiosConfig,
  });
}

export async function deleteTagFromAllRelationships({ brandId, tagId }, axiosConfig = {}) {
  return axios.delete(`/brands/${brandId}/relationships/tags/${tagId}`, {
    ...axiosConfig,
  });
}

export async function searchRelationshipsMultiBrand({ brandIds, limit = 60 }, axiosConfig = {}) {
  const payload = {
    brand_ids: brandIds,
    limit,
  };

  return axios.put('/relationships', payload, { ...axiosConfig });
}

export async function updateInvitationStatus({
  source,
  sourceCreatorId,
  invitedByBrandId,
  invitationStatus,
  emailContent,
}) {
  const params = {
    source,
    invited_by_brand_id: invitedByBrandId,
    source_creator_id: sourceCreatorId,
    invitation_status: invitationStatus,
    email_content: emailContent,
  };

  return axios.put(`/accounts/invitations`, params);
}

export async function searchCreators(
  {
    brandId,
    limit,
    sort,
    lookupName,
    restrictToPlatforms,
    postsPublishedStartDate,
    postsPublishedEndDate,
    tagFilterType,
    tags,
    creatorLocations,
    hasMentionedBrand,
    creatorIds,
    instagramPostType,
    instagramConnectionStatus,
    instagramFollowersGreaterThan,
    instagramFollowersLessThan,
    instagramInterests,
    instagramIsBusiness,
    instagramHandle,
    tiktokConnectionStatus,
    tiktokFollowersGreaterThan,
    tiktokFollowersLessThan,
    tiktokMinEngagementRate,
    tiktokMaxEngagementRate,
    tiktokTTCMStatus,
    tiktokOrganicInterests,
    tiktokPaidInterests,
    tiktokAudienceGender,
    tiktokAudienceAge,
    tiktokMinCreatorRate,
    tiktokMaxCreatorRate,
    tiktokCreatorCurrency,
    tiktokHandle,
    tiktokMinMedianViews,
    tiktokMaxMedianViews,
    youtubeHandle,
    youtubePostType,
    youtubeFollowersGreaterThan,
    youtubeFollowersLessThan,
    youtubeVideoCountGreaterThan,
    youtubeVideoCountLessThan,
    youtubeViewsGreaterThan,
    youtubeViewsLessThan,
    competitiveMentions,
    afterCursor,
  },
  axiosConfig = {},
) {
  const accounts = {
    instagram: {
      status: instagramConnectionStatus,
      followersGreaterThan: instagramFollowersGreaterThan,
      followersLessThan: instagramFollowersLessThan,
      interests: instagramInterests,
      isBusiness: instagramIsBusiness,
      handle: instagramHandle,
    },
    tiktok: {
      status: tiktokConnectionStatus,
      followersGreaterThan: tiktokFollowersGreaterThan,
      followersLessThan: tiktokFollowersLessThan,
      minEngagementRate: tiktokMinEngagementRate,
      maxEngagementRate: tiktokMaxEngagementRate,
      ttcmStatus: tiktokTTCMStatus,
      handle: tiktokHandle,
      interests: tiktokOrganicInterests,
      paidInterests: tiktokPaidInterests,
      minCreatorRate: tiktokMinCreatorRate,
      maxCreatorRate: tiktokMaxCreatorRate,
      creatorCurrency: tiktokCreatorCurrency,
      minMedianViews: tiktokMinMedianViews,
      maxMedianViews: tiktokMaxMedianViews,
      audience: {
        gender: tiktokAudienceGender,
        age: tiktokAudienceAge,
      },
    },
    youtube: {
      handle: youtubeHandle,
      followersGreaterThan: youtubeFollowersGreaterThan,
      followersLessThan: youtubeFollowersLessThan,
      videoCountGreaterThan: youtubeVideoCountGreaterThan,
      videoCountLessThan: youtubeVideoCountLessThan,
      viewsGreaterThan: youtubeViewsGreaterThan,
      viewsLessThan: youtubeViewsLessThan,
    },
  };

  const postType =
    (instagramPostType?.length > 0 ? instagramPostType : undefined) ||
    (youtubePostType?.length > 0 ? youtubePostType : undefined);

  return axios.put(
    `/brands/${brandId}/relationships`,
    {
      limit,
      sort,
      lookupName,
      restrictToPlatforms,
      postsPublishedStartDate,
      postsPublishedEndDate,
      tagFilterType,
      tags,
      locations: creatorLocations,
      hasMentionedBrand,
      creatorIds,
      postType,
      accounts,
      competitiveMentions,
      afterCursor,
    },
    { ...axiosConfig },
  );
}

export async function findOrCreateCreators({ brandId, creators }, axiosConfig = {}) {
  return axios.post(`/brands/${brandId}/creators`, creators, { ...axiosConfig });
}

export async function createRelationships({ url, brandId, creatorIds }) {
  return axios.post(url ?? `/brands/${brandId}/relationships`, { creatorIds });
}

export async function getRelationshipTags(
  { brandIds, limit = 60, offset = 0, nextUrl = null },
  axiosConfig = {},
) {
  if (!Array.isArray(brandIds) || brandIds.length === 0) {
    throw new Error('brandIds must be a non-empty array');
  }

  const params = {
    brand_ids: brandIds.join(','),
    limit,
    offset,
  };

  if (nextUrl) return axios.get(nextUrl, axiosConfig);

  return axios.get('/relationships/tags', {
    params,
    ...axiosConfig,
  });
}

export async function searchRelationships(params, axiosConfig = {}) {
  const { brandIds, limit = 60, afterCursor = null } = params;

  if (!Array.isArray(brandIds) || brandIds.length === 0) {
    throw new Error('brandIds must be a non-empty array');
  }

  const payload = {
    brand_ids: brandIds,
    limit,
    after_cursor: afterCursor,
  };

  Object.keys(payload).forEach((key) => {
    if (payload[key] === null || payload[key] === undefined) {
      delete payload[key];
    }
  });
  return axios.put('/relationships', payload, { ...axiosConfig });
}

export async function fetchCreatorsCount({ brandId }) {
  return axios.put(`/brands/${brandId}/relationships`);
}

export async function fetchAccountPosts(
  { brandId, source, handle, cache, limit, afterCursor, includeAuthorized, includeAllMetrics },
  axiosConfig = {},
) {
  return axios.get('/posts', {
    ...axiosConfig,
    params: {
      brandId,
      source,
      handle,
      cache,
      limit,
      afterCursor,
      includeAuthorized,
      includeAllMetrics,
    },
  });
}

export async function fetchAccountMetrics({ source, handle, brandId }, axiosConfig = {}) {
  return axios.get(`/accounts/${source}/metrics`, {
    ...axiosConfig,
    params: { brandId, handle },
  });
}

export async function fetchAccountAvgWeeklyPosts({ source, handle, brandId }, axiosConfig = {}) {
  return axios.get(`/accounts/${source}/metrics/avg_weekly_posts`, {
    ...axiosConfig,
    params: { brandId, handle },
  });
}

export async function fetchAudienceMetrics({ source, handle, brandId, metric }, axiosConfig = {}) {
  return axios.get(`/accounts/${source}/audience-metrics`, {
    ...axiosConfig,
    params: { brandId, handle, metric },
  });
}

export async function fetchSimilarCreators(
  { brandId, source, handle, sourceCreatorId },
  axiosConfig = {},
) {
  return axios.get(`/accounts/${source}/similar`, {
    ...axiosConfig,
    params: { brandId, handle, sourceCreatorId },
  });
}

export async function addRelationshipAccount({ brandId, creatorId, handle, source }) {
  return axios.post(`/brands/${brandId}/relationships/add_account`, {
    creatorId,
    handle,
    source,
  });
}

export async function removeRelationshipAccount({ brandId, creatorId, source }) {
  return axios.post(`/brands/${brandId}/relationships/remove_account`, {
    creatorId,
    source,
  });
}

export async function fetchCustomFields({ brandId }, axiosConfig = {}) {
  return axios.get(`/brands/${brandId}/relationships/custom_fields`, {
    ...axiosConfig,
    params: {},
  });
}

export async function createCustomFields({ brandId, customFields }, axiosConfig = {}) {
  return axios.post(
    `/brands/${brandId}/relationships/custom_fields`,
    { customFields },
    { ...axiosConfig },
  );
}

export async function updateCustomField(
  { brandId, fieldId, name, showInRequestForm },
  axiosConfig = {},
) {
  return axios.put(
    `/brands/${brandId}/relationships/custom_fields/${fieldId}`,
    { name, showInRequestForm },
    { ...axiosConfig },
  );
}

export async function deleteCustomField({ brandId, fieldId }, axiosConfig = {}) {
  return axios.delete(`/brands/${brandId}/relationships/custom_fields/${fieldId}`, {
    ...axiosConfig,
  });
}

export async function fetchMetaPaidPartnersStatus(
  { handle, brandId, brandInstagramId },
  axiosConfig = {},
) {
  return axios.get(`/brands/${brandId}/meta_paid_partners`, {
    ...axiosConfig,
    params: { brandInstagramId, handle },
  });
}

export async function requestMetaPaidPartners(
  { handle, brandId, brandInstagramId },
  axiosConfig = {},
) {
  return axios.post(
    `/brands/${brandId}/meta_paid_partners`,
    { brandInstagramId, handle },
    { ...axiosConfig },
  );
}

export async function revokeMetaPaidPartners(
  { handle, brandId, brandInstagramId, creatorInstagramId },
  axiosConfig = {},
) {
  return axios.delete(`/brands/${brandId}/meta_paid_partners`, {
    ...axiosConfig,
    params: { brandInstagramId, creatorInstagramId, handle },
  });
}

export async function createManualPayment({
  brandId,
  tiktokHandle,
  instagramHandle,
  campaignName,
  campaignStartDate,
  campaignEndDate,
  recipientType,
  recipientFirstName,
  recipientLastName,
  recipientBusinessName,
  recipientEmail,
  currency,
  amount,
}) {
  return axios.post('/payments/manual-payments', {
    brandId,
    tiktokHandle,
    instagramHandle,
    campaignName,
    campaignStartDate,
    campaignEndDate,
    recipientType,
    recipientFirstName,
    recipientLastName,
    recipientBusinessName,
    recipientEmail,
    currency,
    amount,
  });
}

export async function downloadCreatorDetails({
  brandId,
  socketId,
  creatorIds,
  hasMentionedBrand,
  instagramConnectionStatus,
  instagramFollowersGreaterThan,
  instagramFollowersLessThan,
  instagramIsBusiness,
  instagramInterests,
  instagramPostType,
  lookupName,
  postsPublishedEndDate,
  postsPublishedStartDate,
  restrictToPlatforms,
  sort,
  tagFilterType,
  tags,
  tiktokAudienceAge,
  tiktokAudienceGender,
  tiktokAudienceRegions,
  tiktokConnectionStatus,
  tiktokFollowersGreaterThan,
  tiktokFollowersLessThan,
  tiktokTTCMStatus,
  tiktokMinCreatorRate,
  tiktokMaxCreatorRate,
  tiktokCreatorCurrency,
  tiktokMinMedianViews,
  tiktokMaxMedianViews,
  tiktokMinEngagementRate,
  tiktokMaxEngagementRate,
  tiktokPaidInterests,
  tiktokOrganicInterests,
  campaignName,
}) {
  return axios.post(`/brands/${brandId}/relationships/creator_details_csv`, {
    socketId,
    creatorIds,
    hasMentionedBrand,
    lookupName,
    postType: instagramPostType,
    postsPublishedEndDate,
    postsPublishedStartDate,
    restrictToPlatforms,
    sort,
    tagFilterType,
    tags,
    campaignName,
    accounts: {
      instagram: {
        status: instagramConnectionStatus,
        followersGreaterThan: instagramFollowersGreaterThan,
        followersLessThan: instagramFollowersLessThan,
        interests: instagramInterests,
        isBusiness: instagramIsBusiness,
      },
      tiktok: {
        status: tiktokConnectionStatus,
        followersGreaterThan: tiktokFollowersGreaterThan,
        followersLessThan: tiktokFollowersLessThan,
        ttcmStatus: tiktokTTCMStatus,
        minCreatorRate: tiktokMinCreatorRate,
        maxCreatorRate: tiktokMaxCreatorRate,
        creatorCurrency: tiktokCreatorCurrency,
        minMedianViews: tiktokMinMedianViews,
        maxMedianViews: tiktokMaxMedianViews,
        minEngagementRate: tiktokMinEngagementRate,
        maxEngagementRate: tiktokMaxEngagementRate,
        paidInterests: tiktokPaidInterests,
        interests: tiktokOrganicInterests,
        audience: {
          regions: tiktokAudienceRegions,
          gender: tiktokAudienceGender,
          age: tiktokAudienceAge,
        },
      },
    },
  });
}

export async function downloadCreatorPosts({
  brandId,
  socketId,
  creatorIds,
  creatorLocations,
  hasMentionedBrand,
  instagramConnectionStatus,
  instagramFollowersGreaterThan,
  instagramFollowersLessThan,
  instagramIsBusiness,
  instagramInterests,
  instagramPostType,
  lookupName,
  postsPublishedEndDate,
  postsPublishedStartDate,
  restrictToPlatforms,
  sort,
  tagFilterType,
  tags,
  tiktokAudienceAge,
  tiktokAudienceGender,
  tiktokAudienceRegions,
  tiktokConnectionStatus,
  tiktokFollowersGreaterThan,
  tiktokFollowersLessThan,
  tiktokMinEngagementRate,
  tiktokMaxEngagementRate,
  tiktokInterests,
  tiktokTTCMStatus,
  ttoCampaignId,
}) {
  return axios.put(`/brands/${brandId}/relationships/export_posts`, {
    socketId,
    creatorIds,
    sort,
    lookupName,
    restrictToPlatforms,
    postsPublishedStartDate,
    postsPublishedEndDate,
    tagFilterType,
    tags,
    creatorLocations,
    hasMentionedBrand,
    ttoCampaignId,
    postType: instagramPostType,
    accounts: {
      instagram: {
        status: instagramConnectionStatus,
        followersGreaterThan: instagramFollowersGreaterThan,
        followersLessThan: instagramFollowersLessThan,
        interests: instagramInterests,
        isBusiness: instagramIsBusiness,
      },
      tiktok: {
        status: tiktokConnectionStatus,
        followersGreaterThan: tiktokFollowersGreaterThan,
        followersLessThan: tiktokFollowersLessThan,
        minEngagementRate: tiktokMinEngagementRate,
        maxEngagementRate: tiktokMaxEngagementRate,
        ttcmStatus: tiktokTTCMStatus,
        interests: tiktokInterests,
        audience: {
          regions: tiktokAudienceRegions,
          gender: tiktokAudienceGender,
          age: tiktokAudienceAge,
        },
      },
    },
  });
}

export const fetchShopifyProductList = ({
  brandId,
  limit,
  name,
  sku,
  nameOrSku,
  category,
  type,
  price,
  inventoryCount,
  afterCursor,
}) =>
  axios.put(`/brands/${brandId}/shopify/products`, {
    limit,
    filters: {
      name,
      sku,
      nameOrSku,
      category,
      type,
      price,
      inventoryCount,
    },
    afterCursor,
  });

export const fetchShopifyProductCategories = ({ brandId }) =>
  axios.get(`/brands/${brandId}/shopify/product_categories`);

export const fetchShopifyProductTypes = ({ brandId }) =>
  axios.get(`/brands/${brandId}/shopify/product_types`);

export async function fetchShopifyGiftOrders(
  {
    brandId,
    creatorIds,
    orderIds,
    summary = false,
    includeDrafts = false,
    limit,
    offset,
    campaignId,
  },
  axiosConfig = {},
) {
  return axios.get(`/brands/${brandId}/shopify/orders`, {
    ...axiosConfig,
    params: {
      campaignId,
      creatorIds: creatorIds?.join(','),
      orderIds: orderIds?.join(','),
      summary,
      includeDrafts,
      limit,
      offset,
    },
  });
}

export async function createShopifyGiftOrder(
  { brandId, creatorIds, productVariants, campaignId },
  axiosConfig = {},
) {
  return axios.post(
    `/brands/${brandId}/shopify/orders`,
    { creatorIds, productVariants, campaignId },
    { ...axiosConfig },
  );
}

export async function disconnectShopifyAccount({ brandId }, axiosConfig = {}) {
  return axios.delete(`/brands/${brandId}/shopify/webhooks`, axiosConfig);
}

export async function connectShopifyAccount({ brandId }, axiosConfig = {}) {
  return axios.post(`/brands/${brandId}/shopify/connected`, axiosConfig);
}

export async function fetchInfluentialFans(
  { brandId, source, sort, limit, afterCursor },
  axiosConfig = {},
) {
  return axios.get(`/accounts/${source}/brands/${brandId}/influential_fans`, {
    ...axiosConfig,
    params: {
      sort,
      limit,
      afterCursor,
    },
  });
}

export async function fetchCompetitiveMentions(
  {
    brandId,
    creatorId,
    limit,
    offset,
    sort,
    sources,
    competitorIds,
    isKnownCompetitor,
    excludedBrandAccountIds,
  },
  axiosConfig = {},
) {
  const payload = {
    sources,
    competitorIds,
    isKnownCompetitor,
    excludedBrandAccountIds,
  };

  return axios.put(`/brands/${brandId}/relationships/${creatorId}/competitive_mentions`, payload, {
    ...axiosConfig,
    params: { limit, offset, sort },
  });
}

export async function fetchCompetitiveMentionPosts(
  { brandId, creatorId, sources, competitorIds, limit, offset, excludedBrandAccountIds },
  axiosConfig = {},
) {
  const payload = {
    sources,
    competitorIds,
    excludedBrandAccountIds,
  };

  return axios.put(
    `/brands/${brandId}/relationships/${creatorId}/competitive_mentions/posts`,
    payload,
    {
      ...axiosConfig,
      params: { limit, offset },
    },
  );
}

export async function fetchBrandedContent({ brandId, handle, source }, axiosConfig = {}) {
  return axios.get(`/accounts/${source}/branded_content`, {
    ...axiosConfig,
    params: { brandId, handle },
  });
}

export async function fetchCreatorAiInsights({ brandId, creatorId }, axiosConfig = {}) {
  return axios.get(`/brands/${brandId}/relationships/${creatorId}/ai_profile_insights`, {
    ...axiosConfig,
  });
}

export async function generateCreatorAiInsights({ brandId, creatorId }, axiosConfig = {}) {
  return axios.post(
    `/brands/${brandId}/relationships/${creatorId}/ai_profile_insights`,
    {},
    {
      ...axiosConfig,
    },
  );
}

export async function fetchPastBrandPartnerships({ brandId, handle, source }, axiosConfig = {}) {
  return axios.get(`/accounts/${source}/past_brand_partnerships`, {
    ...axiosConfig,
    params: { brandId, handle },
  });
}

export async function fetchNaturalLanguageSearchAccounts(
  { brandId, source, userRequest },
  axiosConfig = {},
) {
  return axios.get('/natural_language_search/accounts', {
    ...axiosConfig,
    params: { brandId, source, userRequest },
  });
}
